/* Load the shared native icon presentation; no purchase or color handling. */
(function(factory){
  if(typeof module==='object'&&module.exports)module.exports=factory();
  else window.FizzyIconLoader=factory();
})(function(){
  'use strict';
  function loadPresentation(doc, config) {
    const win = doc.defaultView;
    if (win.FizzyIconStrip) return Promise.resolve(win.FizzyIconStrip);
    if (win.FizzyIconUiReady) return win.FizzyIconUiReady;
    if (!config.iconStripUrl) return Promise.reject(new Error('Icon UI unavailable'));
    if (config.iconStripCssUrl && !doc.querySelector('link[data-fizzy-icon-css]')) {
      const css = doc.createElement('link'); css.rel = 'stylesheet'; css.href = config.iconStripCssUrl;
      css.dataset.fizzyIconCss = ''; doc.head.append(css);
    }
    win.FizzyIconUiReady = new Promise((resolve, reject) => {
      const script = doc.createElement('script'); script.src = config.iconStripUrl;
      script.dataset.fizzyIconLibrary = '';
      script.addEventListener('load', () => win.FizzyIconStrip ? resolve(win.FizzyIconStrip) : reject(new Error('Icon UI missing')), { once: true });
      script.addEventListener('error', () => reject(new Error('Icon UI unavailable')), { once: true });
      doc.head.append(script);
    });
    return win.FizzyIconUiReady;
  }
  return { loadPresentation };
});
